<template>
  <div class="component-wrap" :class="{ overflow: exercise.code !== 'KY' }">
    <component
      ref="quizze"
      :key="exercise.code"
      :is="quizzes[exercise.code]"
      @changeOption="changOption"
      :exercise="exercise"
      :userAnswer="userAnswer"
      :is-show-explain="isShowExplain"
      :is-show-score="false"
      :is-done="isDone"
      :is-random="isRandomOption"
      :mode="exercise.mode"
      :is-directly-complete="false"
      :is-exam="isExam"
      :extras="exercise.extras"
      :play-times="exercise.playTimes || playTimes"
      :ignore-case="isIgnoreCase"
      auth-action="/api/home/student/user/get/xunfeiWsAuth"
      :can-drag="canDrag"
      @switch="isShowExplain = !isShowExplain"
      @error="audioError"
      @played="played"
      @ended="onWKEnd"
      @complete="complete"
      @last="handlerLast"
      @change="change">
    </component>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import 'vanthink-components/icon/iconfont.css';
import TYLJ from 'vanthink-components/components/quiz/TYLJ/TYLJ-U.vue';
import JXZH from 'vanthink-components/components/quiz/JXZH/JXZH-U.vue';
import KY from 'vanthink-components/components/quiz/KY/KY-U.vue';
import DX from 'vanthink-components/components/quiz/DX/DX-U.vue';
import QHLJ from 'vanthink-components/components/quiz/QHLJ/QHLJ-U.vue';
import MED from 'vanthink-components/components/quiz/MED/MED-U.vue';
import BQWZ from 'vanthink-components/components/quiz/BQWZ/BQWZ-U.vue';
import WK from 'vanthink-components/components/quiz/WK/WK-U.vue';
import CHXZ from 'vanthink-components/components/quiz/CHXZ/CHXZ-U.vue';
import DCTX from 'vanthink-components/components/quiz/DCTX/DCTX-U.vue';
import SK from 'vanthink-components/components/quiz/SK/SK-U.vue';
import HYDC from 'vanthink-components/components/quiz/HYDC/HYDC-U.vue';
import DCPX from 'vanthink-components/components/quiz/DCPX/DCPX-U.vue';
import YDLJ from 'vanthink-components/components/quiz/YDLJ/YDLJ-U.vue';
import THXZ from 'vanthink-components/components/quiz/THXZ/THXZ-U.vue';
import XCTK from 'vanthink-components/components/quiz/XCTK/XCTK-U.vue';
import WXTK from 'vanthink-components/components/quiz/WXTK/WXTK-U.vue';
import BS from 'vanthink-components/components/quiz/BS/BS-U.vue';
import TK from 'vanthink-components/components/quiz/BQ/BQ-U.vue';
import utils from '@/services/utils';

export default {
  props: {
    exercises: {
      type: Array,
      required: true,
    },
    userAnswer: {
      default: null,
    },
    isBacktrack: {
      type: Number,
      default: 0,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    playTimes: {
      type: Number,
      default: 1,
    },
    projectCode: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      newExercises: [],
      wrongExercises: [],
      results: [],
      exerciseIndex: 0,
      isShowExplain: true,
      isDone: false,
      autoNext: true,
      canDrag: 0,
      isRight: 0,
      quizzes: {
        QHLJ,
        KY,
        DX,
        TYLJ,
        JXZH,
        MED,
        BQWZ,
        WK,
        CHXZ,
        DCTX,
        SK,
        HYDC,
        DCPX,
        YDLJ,
        THXZ,
        XCTK,
        WXTK,
        BS,
        TK,
      },
    };
  },
  watch: {
    exercise: {
      handler() {
        const isShowWKHint = utils.storage('WKHint');
        if (this.exercise.code === 'WK' && !isShowWKHint) {
          MessageBox({
            title: '温馨提示',
            message: '点击下方全屏按钮,观看效果更佳哦!',
            beforeClose: (action, instance, done) => {
              utils.storage('WKHint', 1);
              done();
            },
          });
        }
        if (this.exercise
          && (this.exercise.code === 'WK' || this.exercise.code === 'BS' || this.exercise.code === 'MRD' || this.exercise.code === 'SK' || (this.exercise.code === 'CHXZ' && !this.isExam))) {
          this.isRight = 1;
          this.isDone = true;
        } else {
          this.isRight = 0;
          this.isDone = false;
        }
      },
      deep: true,
      immediate: true,
    },
    exercises: {
      handler() {
        this.initNewExercises();
      },
      deep: true,
    },
    newExercises() {
      if (this.newExercises.length === 0) {
        this.$emit('finish', {
          results: this.results,
        });
      } else {
        this.$emit('exerciseChange', {
          ...this.exercise,
        });
      }
    },
    exerciseIndex() {
      this.$emit('exerciseChange', {
        id: this.exercise.id,
        exerciseIndex: this.exerciseIndex,
      });
    },
  },
  computed: {
    exercise() {
      return this.newExercises[this.exerciseIndex] || {};
    },
    isDirectlyDone() {
      return this.exercise.code === 'MED'
        || this.exercise.code === 'WK'
        || this.exercise.code === 'SK'
        || this.exercise.code === 'BS';
    },
    isRandomOption() {
      return (this.exercise.code === 'CHXZ' || this.exercise.code === 'DX') && !this.isExam;
    },
    isIgnoreCase() {
      return this.projectCode === 'Chinese';
    },
  },
  created() {
    this.initNewExercises();
  },
  mounted() {
    if (this.exercise.videoDone) {
      this.canDrag = 1;
    }
  },
  methods: {
    complete() {
      if (this.isExam) return;
      if ((this.exercise.code === 'QHLJ'
        || this.exercise.code === 'DCTX'
        || this.exercise.code === 'HYDC'
        || (this.exercise.code === 'SK' && this.exercise.mode === 2)) && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.isDone = true;
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 1000);
      } else {
        this.next();
      }
    },
    onWKEnd() {
      this.canDrag = 1;
      utils.post('/api/home/student/play/basic/saveVideoPlay', {
        data: {
          url: this.exercise.video,
        },
      })
        .then();

      utils.message('可以点击右下角“→”进入下一题哦');
    },
    initNewExercises() {
      if (this.status) {
        this.canDrag = 1;
      }
      this.newExercises = utils.clone(this.exercises).map(item => ({ ...item, errorCount: 0 }));
    },
    audioError({ message }) {
      utils.error(message);
    },
    played() {
      if (((this.exercise.code === 'CHXZ' && this.exercise.mode === 2)
        || this.exercise.code === 'DCPX') && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 200);
      }
    },
    speak() {
      if (this.$refs.quizze.getFocus) {
        this.$refs.quizze.getFocus();
      }
    },
    change(payload) {
      this.$nextTick(() => {
        this.isRight = payload.isRight;
        const exercise = {
          ...this.exercise,
          ...payload,
          isRight: payload.isRight,
          userAnswer: this.exercise.code === 'TK' ? { answer: payload.answer } : payload.answer,
          isComplete: payload.isComplete,
        };
        this.$emit('change', exercise);
        if (!this.isExam && this.autoNext) {
          this.handlerAutoNext();
        }
      });
    },
    changOption(payload) {
      this.exercise.formatOptions = payload.formatOptions;
    },
    correctExercise() {
      /* eslint-disable no-lonely-if */
      this.pushResults();

      if (this.type === 'level') {
        this.removeNewExercise();
        return;
      }

      if (this.isRight) {
        this.removeNewExercise();
      } else {
        this.exercise.errorCount += 1;
        this.backwardsInsertExercise();
        this.wrongExercises.push(this.exercise);
      }
    },
    // 错题重练 向后插入
    backwardsInsertExercise() {
      if (this.newExercises.length <= 1) {
        const last = Object.assign({}, this.newExercises[0]);
        this.newExercises = [last];
        return;
      }

      const [first, ...others] = this.newExercises;
      if (this.newExercises.length > 2) {
        this.newExercises = others;
        this.newExercises.splice(2, 0, first);
      } else {
        this.newExercises = [...others, first];
      }
    },
    removeNewExercise() {
      if (this.newExercises.length === 1) {
        this.newExercises = [];
      } else {
        const [, ...others] = this.newExercises;
        this.newExercises = [...others];
      }
    },
    pushResults() {
      let answer;
      if (this.exercise.userAnswer) {
        answer = this.exercise.userAnswer;
      } else {
        if (this.exercise.code === 'DX') {
          answer = -1;
        } else {
          answer = [];
        }
      }
      this.results.push({
        id: this.exercise.id,
        code: this.exercise.code,
        errorCount: this.exercise.errorCount,
        isRight: this.isRight || false,
        answer,
      });

      if (this.results.length === 20
        && this.exercises.length >= 50
        && this.quizType === 'active_review') {
        this.$emit('finish', {
          results: this.results,
          spend: this.spend,
          isHalf: true,
        });
      }
    },
    handlerAutoNext() {
      // if ((this.exercise.code === 'QHLJ' || this.exercise.code === 'DCTX') && this.isRight) {
      //   this.autoNext = false;
      //   clearTimeout(this.delay);
      //   this.isDone = true;
      //   this.delay = setTimeout(() => {
      //     this.autoNext = true;
      //     this.next();
      //   }, 1000);
      // }

      if (this.exercise.code === 'CHXZ' && this.exercise.mode !== 2 && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
        }, 1000);
      }
    },
    handlerLast() {
      if (!this.isExam) return;
      if (this.exerciseIndex >= this.newExercises.length - 1) {
        utils.message('已经是最后一题了', 'warning');
      } else {
        this.exerciseIndex += 1;
      }
    },
    prev() {
      if (this.exerciseIndex <= 0) {
        utils.message('已经是第一题了', 'warning');
        return;
      }
      this.exerciseIndex -= 1;
    },
    next(type) {
      if (this.isExam) {
        if (this.exerciseIndex >= this.newExercises.length - 1) {
          utils.message('已经是最后一题了', 'warning');
        } else if (type !== 'text' || this.exercise.code !== 'QHLJ') {
          this.exerciseIndex += 1;
        }
      } else {
        if (this.delay) {
          clearTimeout(this.delay);
          if (!this.autoNext) {
            this.autoNext = true;
          }
        }
        if (this.isDirectlyDone) {
          this.isDone = true;
        }
        if (this.isDone) {
          this.correctExercise();
          this.$emit('result', {
            results: this.results,
            remainQuizzes: this.newExercises,
          });
          this.isDone = false;
        } else {
          this.isDone = true;
        }
      }
    },
    clear() {
      this.$refs.quizze.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
  .component-wrap {
    height: 100%;
    color: #333;
    font-family: STFangsong, NSimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
    background: #fff;
    border-radius: 24px;
    &.overflow {
      overflow-y: auto;
    }
    /deep/ .control-bar {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    /* 由于组件内修改了解析的行高，需要同步设置个别游戏的解析序号行高，以保持一直 */
    /deep/ .bqwz-container {
      .wrap-article {
        .options {
          .op-btn {
            .op-index {
              font-size: 18px;
              line-height: 2;
            }
          }
        }
      }
    }
    /deep/ .parse{
      font-size: 18px;
      .parse-text {
        width: 60px;
        line-height: 2;
      }
      .parse-content {
        width: calc(100% - 60px);
        line-height: 2;
      }
    }
    /deep/ .hint {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
  }
</style>
